import { Page, PageTitle } from "@/components/page"
import { Card, CardContent } from "@/components/ui/card"
import { Input } from "@/components/ui/input"
import { ToMarkdown } from "@/components/ui/tomarkdown"
import { releaseNotes as notes } from "@/lib/releaseNotes"
import { Sparkles } from "lucide-react"
import { useRef, useState } from "react"

export const releaseNotesPage = {
  title: "Release Notes",
  description: "What's new in the app.",
  route: "/release-notes",
  url: "/release-notes",
  icon: Sparkles,
  component,
  resource: "agents",
  action: "read",
} satisfies PageConfig

// export const releaseNotesPage = {
//   title: "Release Notes",
//   description: "What's new in the app.",
//   route: "/settings/release-notes",
//   url: "/settings/release-notes",
//   icon: Sparkles,
//   component,
//   resource: "apikeys",
//   group: "settings",
// } satisfies PageConfig


function formatDate(iso: string) {
  if (!iso) return ""
  return new Date(iso + "T00:00:00").toLocaleDateString(undefined, { year: "numeric", month: "long", day: "numeric" })
}

function component() {
  const [query, setQuery] = useState("")
  const [search, setSearch] = useState("")
  const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  const term = search.trim()
  const filtered = term ? notes.filter((n) => n.content.toLowerCase().includes(term.toLowerCase())) : notes

  function handleSearchChange(e: React.ChangeEvent<HTMLInputElement>) {
    setQuery(e.target.value)
    if (debounceRef.current) clearTimeout(debounceRef.current)
    debounceRef.current = setTimeout(() => setSearch(e.target.value), 300)
  }

  return (
    <Page>
      <div className="pb-8">
        <PageTitle>
          <Input value={query} onChange={handleSearchChange} placeholder="Search..." className="w-64" />
        </PageTitle>
        <div className="mb-4" />
        <div className="rgrid">
          {filtered.map((note) => (
            <div className="row" key={note.slug}>
              <div className="rc-12">
                <Card>
                  <CardContent className="pt-6">
                    <div className="text-sm text-muted-foreground mb-2">{formatDate(note.date)}</div>
                    <ToMarkdown variant="document" highlight={term}>{note.content}</ToMarkdown>
                  </CardContent>
                </Card>
              </div>
            </div>
          ))}
          {notes.length === 0 && <div className="text-muted-foreground">No release notes yet.</div>}
          {notes.length > 0 && filtered.length === 0 && <div className="text-muted-foreground">No matches.</div>}
        </div>
      </div>
    </Page>
  )
}
